// extracted by mini-css-extract-plugin
export default {"_404_background":"_404-style__404_background__ISDYT","_404_foreground":"_404-style__404_foreground__PdZis"};